import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IdleTimeoutModalComponent } from './shared/idle-timeout-modal/idle-timeout-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, IdleTimeoutModalComponent],
  template: `
    <router-outlet />
    <app-idle-timeout-modal />
  `,
})
export class AppComponent {}
